import { render, staticRenderFns } from "./BlockType105.vue?vue&type=template&id=55b1eed6&scoped=true"
import script from "./BlockType105.vue?vue&type=script&lang=ts"
export * from "./BlockType105.vue?vue&type=script&lang=ts"
import style0 from "./BlockType105.vue?vue&type=style&index=0&id=55b1eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b1eed6",
  null
  
)

export default component.exports